import { createAction, props } from '@ngrx/store';
import { SearchDataRequest, SearchResult } from 'src/app/services/NewSearchDataWebService';

export const searchHearings = createAction(
  '[Hearings] Search Hearings',
  props<{ 
    payload: SearchDataRequest, 
    context: string, 
    includePendingActionDocs?: string,
    includeDocCountByDocumentType?: string,
    includeDocList?: Array<string>, 
    excludeDocList?: Array<string> 
  }>()
);
export const searchHearingsSuccess = createAction(
  '[Hearings] Search Hearings Success',
  props<{ response: SearchResult, context: string }>()
);

export const searchHearingsFailure = createAction(
  '[Hearings] Search Hearings Failure',
  props<{ error: any, context: string }>()
);

export const clearSearchResults = createAction('[Hearings] Clear Search Results');
